import clsx from "clsx";
import React from "react";

interface SeparatorProps {
  orientation?: "horizontal" | "vertical";
  className?: string;
}
const Separator: React.FC<SeparatorProps> = ({
  orientation = "horizontal",
  className,
}) => {
  return (
    <div
      className={clsx(
        orientation === "horizontal"
          ? "border-t border-[#40565A]"
          : "border-l border-[#40565A]",
        className
      )}
    />
  );
};

export default Separator;
